import {loadBuildingMeetingRoomAmenities} from '@lib/store/src/data/meetingRooms/actions';
import {getMeetingRoomAmenitiesByBuilding} from '@lib/store/src/data/meetingRooms/selectors';
import {useAppDispatch} from '@lib/store/src/hooks/useAppDispatch';
import {useAppSelector} from '@lib/store/src/hooks/useAppSelector';
import {withAsyncThunkErrorHandling} from '@lib/store/src/ui/withErrorHandling';
import {useEffect, useMemo} from 'react';

export const useMeetingRoomAmenities = () => {
  const dispatch = useAppDispatch();

  const {status, meetingRoomAmenitiesByBuilding} = useAppSelector(getMeetingRoomAmenitiesByBuilding);

  useEffect(() => {
    if (status !== 'NotLoaded') return;

    dispatch(withAsyncThunkErrorHandling(() => loadBuildingMeetingRoomAmenities()));
  }, [dispatch, status]);

  return useMemo(
    () => ({
      status,
      meetingRoomAmenitiesByBuilding,
    }),
    [meetingRoomAmenitiesByBuilding, status],
  );
};
